import Parrain from './parrain';

export const parrainConfig: Parrain[] = [
    {
        logo: {
            id: null,
            url: null,
            urlExt: null,
            extension: null,
        },
        id: null,
        name: null,
        fullname:null,
        country: null,
        city:null,
        street:null,
        zipcode:null,
        phoneNumber:null,
        urlWebSite: null,
        isMainSponsor: false,
        styles: {
            logo: {
                size: {
                    sidebarLeftBottom: {
                        classnameWidth: null,
                        classnameHeight: null,
                        width: null,
                        height: null,
                    },
                    bottomBarRight: {
                        classnameWidth: null,
                        classnameHeight: null,
                    },
                    advertising: {
                        classnameWidth: null,
                        classnameHeight: null,
                    },
                    bannerSide: { classnameWidth: null, classnameHeight: null },
                    bannerFeed: { classnameWidth: null, classnameHeight: null },
                    partnerPlace: { classnameWidth: null, classnameHeight: null },
                },
            },
        },
        customize: {
            needBackground: true,
            backgroundColor: null,
            padding: null,
            borderRounded: true
        }
    },
];
